import ListFilters from '@/common/components/ListFilters'
import Table from '@/common/components/Table'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { CompaniesTransformer } from '@/features/companies/services/companiesTransformer'
import { useEstablishmentCompanies } from '@/features/establishments/hooks/useEstablishmentCompanies'
import { consumptionDataColumns } from '@/features/tmaisUsers/constants/consumptionDataColumns.constant'
import { useTmaisUserConsumptions } from '@/features/tmaisUsers/hooks/useTmaisUserConsumptions'
import { ConsumptionDataTransformer } from '@/features/tmaisUsers/services/consumptionDataTransformer'
import { ConsumptionData, ConsumptionTableItem } from '@/features/tmaisUsers/types/tmaisUserConsumptions.type'
import { useState } from 'react'

interface ConsumptionDataTabProps {
  userId: string
}

const ConsumptionDataTab = ({ userId }: ConsumptionDataTabProps) => {
  const { filterParams, setFilterParams } = useFilterParams()
  const [searchEstablishments, setSearchEstablishments] = useState('')

  const { data: establishmentOptions } = useEstablishmentCompanies({
    filters: { search: searchEstablishments, tmaisModuleEnabled: true },
    mapper: Mapper.mapWithTransformer({ transformer: CompaniesTransformer.optionsTransformer() }),
  })

  const {
    data: consumptions,
    meta,
    isPending,
  } = useTmaisUserConsumptions<ConsumptionTableItem[]>({
    userId,
    filters: {
      page: filterParams.page || 1,
      establishmentCompanyId: filterParams.establishmentCompanyId?.value,
    },
    mapper: Mapper.mapWithTransformer<ConsumptionData[], ConsumptionTableItem[]>({
      transformer: ConsumptionDataTransformer.tableTransformer(),
    }),
  })

  return (
    <div className="flex flex-col gap-2">
      <ListFilters
        filters={[
          {
            placeholder: 'Estabelecimento',
            onInputChange: setSearchEstablishments,
            onChange: (establishment) =>
              setFilterParams((prev) => ({
                ...prev,
                establishmentCompanyId: establishment,
              })),
            value: filterParams.establishmentCompanyId,
            options: [{ label: 'Todos', value: '' }, ...(establishmentOptions || [])],
          },
        ]}
      />

      <Table
        className="max-h-[calc(100vh-232px)]"
        columns={consumptionDataColumns}
        rows={consumptions || []}
        rowEmptyValue="--"
        isLoadingData={isPending}
        page={filterParams.page || 1}
        totalPages={meta?.total_pages || 1}
        totalCount={meta?.total}
        hasPagination
        setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
      />
    </div>
  )
}

export default ConsumptionDataTab
